import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { 
  Trash2,
  ExternalLink,
  ArrowRightLeft,
  Droplets,
  TrendingUp,
  CheckCircle2,
  XCircle
} from 'lucide-react';

const BlumTokenCard = ({ token, tonPrice, onRemove, onTrade }) => {
  
  const formatNumber = (num, decimals = 2) => {
    if (num === null || num === undefined) return '—';
    if (num >= 1e9) return (num / 1e9).toFixed(decimals) + 'B';
    if (num >= 1e6) return (num / 1e6).toFixed(decimals) + 'M';
    if (num >= 1e3) return (num / 1e3).toFixed(decimals) + 'K';
    return num.toFixed(decimals);
  };

  const formatPrice = (price) => {
    if (!price) return '$0';
    if (price < 0.00001) return `$${price.toExponential(2)}`;
    if (price < 0.01) return `$${price.toFixed(6)}`;
    if (price < 1) return `$${price.toFixed(4)}`;
    return `$${price.toFixed(2)}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Card className="bg-white/5 backdrop-blur-sm border-white/10 hover:border-purple-500/50 transition-all">
      <CardContent className="p-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center text-white font-bold">
              {token.symbol?.charAt(0) || '?'}
            </div>
            <div>
              <div className="text-white font-medium flex items-center gap-2">
                {token.symbol || 'UNKNOWN'}
                <a 
                  href={`https://tonviewer.com/${token.master_address}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-purple-400 hover:text-purple-300"
                >
                  <ExternalLink className="h-3 w-3" />
                </a>
              </div>
              <div className="text-purple-300 text-xs">
                {token.name || 'Unknown'}
              </div>
            </div>
          </div>

          {token.trading_enabled ? (
            <Badge className="bg-green-500/20 text-green-400 border-green-500/30 text-xs">
              <CheckCircle2 className="h-3 w-3 mr-1" />
              Active
            </Badge>
          ) : (
            <Badge className="bg-red-500/20 text-red-400 border-red-500/30 text-xs">
              <XCircle className="h-3 w-3 mr-1" />
              Disabled
            </Badge>
          )}
        </div>

        {/* Price */}
        <div className="mb-3">
          <div className="text-2xl font-bold text-white">
            {formatPrice(token.last_price_usd)}
          </div>
          <div className="text-purple-300 text-sm">
            {token.last_price_ton?.toFixed(9)} TON
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-2 mb-3">
          <div className="bg-white/5 rounded p-2">
            <div className="flex items-center gap-1 text-purple-300 text-xs">
              <Droplets className="h-3 w-3" />
              Liquidity
            </div>
            <div className="text-white text-sm font-medium">
              {formatNumber(token.ton_liq_collected)} TON
            </div>
          </div>
          <div className="bg-white/5 rounded p-2">
            <div className="flex items-center gap-1 text-purple-300 text-xs">
              <TrendingUp className="h-3 w-3" />
              Supply
            </div>
            <div className="text-white text-sm font-medium">
              {formatNumber(token.total_supply)}
            </div>
          </div>
        </div>

        {/* Last Updated */}
        <div className="text-purple-400 text-xs mb-3">
          Обновлено: {formatDate(token.last_updated)}
        </div>

        {/* Actions */}
        <div className="flex gap-2">
          <Button 
            size="sm"
            onClick={onTrade}
            className="flex-1 bg-purple-500 hover:bg-purple-600 text-white"
          >
            <ArrowRightLeft className="h-4 w-4 mr-1" />
            Trade
          </Button>
          <Button 
            size="sm"
            variant="outline"
            onClick={onRemove}
            className="bg-white/5 border-white/20 text-red-400 hover:bg-red-500/20 hover:border-red-500/30"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default BlumTokenCard;


